import { createActionTypes, createApiActions } from '../rootActions';
import {
  ComingNomenclatureReportType,
  InvoiceParams,
  InvoiceParamsRequest,
  ReportPassport,
  ReportPassportRequest,
  SetReportPassportRequest,
  TtnParameter,
  TtnParameterSetRequest,
} from './types';

export const getTtnParameters = createApiActions<Pick<TtnParameterSetRequest, 'requestWorkId'>, TtnParameter>(
  createActionTypes('GET_TTN_PARAMETERS'),
);

export const setTtn = createApiActions<TtnParameterSetRequest, Blob>(createActionTypes('SET_TTN'));

export const comingNomenclatureReport = createApiActions<ComingNomenclatureReportType, Blob>(
  createActionTypes('COMING_NOMENCLATURE_REPORT'),
);

export const getInvoice = createApiActions<InvoiceParamsRequest, InvoiceParams>(createActionTypes('GET_INVOICE'));

export const setInvoice = createApiActions<InvoiceParams, Blob>(createActionTypes('SET_INVOICE'));

export const getReportPassport = createApiActions<ReportPassportRequest, ReportPassport>(
  createActionTypes('GET_REPORT_PASSPORT'),
);

export const setReportPassport = createApiActions<SetReportPassportRequest, Blob>(
  createActionTypes('SET_REPORT_PASSPORT'),
);
